import AddInventoryForm from './AddInventoryForm';

export default AddInventoryForm;



// WEBPACK FOOTER //
// ./src/components/forms/AddInventoryForm/index.jsx